import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="prevent-enter"
export default class extends Controller {
  connect() {
    this.element.addEventListener('keydown', this.preventEnterSubmit);
  }

  disconnect() {
    this.element.removeEventListener('keydown', this.preventEnterSubmit);
  }

  preventEnterSubmit(event) {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  }
}
